import { useQuery } from 'react-query';

import userService from 'resources/user/user.service';

/**
 *
 * @param {string[]} userIds
 * @returns {import('@supabase/supabase-js').User[]} users
 */
const getUsersByIds = async (userIds) => {
  const clients = await userService.getUsersByIds(userIds);

  return clients;
};

/**
 *
 * @param {string[]} userIds
 * @param {import('react-query').UseQueryOptions} queryOptions
 * @returns {import('react-query').UseQueryResult<import('@supabase/supabase-js').User[], Error>}
 */
export default function useGetUsersByIds(userIds, queryOptions) {
  return useQuery(
    ['users.getUsersByIds', userIds],
    () => getUsersByIds(userIds),
    queryOptions,
  );
}
